module.exports = __webpack_public_path__ + "static/media/03A.e8ef2c4e.png";